import { AdminPermission } from "../Me";
import { PermissionType } from "./PermissionType";

export interface AdminPermissionsOnModule {
    readonly canList?: boolean;                     //* Voir la liste des contenu
    readonly canRead?: boolean;                     //* voir le détail d'un contenu
    readonly canCreate?: boolean;                   //! Créer un contenu
    readonly canImport?: boolean;                   //* Importer
    readonly canExport?: boolean;                   //* Exporter
    readonly canSave?: boolean;                     //* Sauvegarder
    readonly canRemove?: boolean;                   //* Supprimer

    readonly canEditName?: boolean;                 //* Sauvegarder
    readonly canEditExternalReference?: boolean;    //* Supprimer

}

export class AdminPermissions {
    public static has = (permission: PermissionType, permissions: Array<PermissionType>): boolean => {
        return permissions.includes(permission);
    }

    public static hasWritePermission = (permissions: Array<PermissionType> = []): boolean => {
        return permissions.includes(PermissionType.Write);
    }

    public static hasReadPermission = (permissions: Array<PermissionType> = []): boolean => {
        return permissions.includes(PermissionType.Read);
    }

    //#region //* CONTENT MODULE

    public static toPermissions = (permissions: Array<PermissionType> = []): AdminPermissionsOnModule => {
        return {
            canList: permissions.length > 0,
            canRead: permissions.length > 0,
            canCreate: AdminPermissions.has(PermissionType.ContentCreate, permissions),
        };
    }

    //#endregion

    //#region //* ADMIN MODULE

    public static filter = (permissions: Array<AdminPermission>, moduleCode: string): Array<PermissionType> => {
        return permissions.filter((p) => p.module === moduleCode).map((x) => x.permission);
    }

    public static toAdminPermissions = (code: string, perms: Array<AdminPermission> = []): AdminPermissionsOnModule => {
        const permsOnModule: Array<PermissionType> = perms
            .filter((p) => p.module === code)
            .map((x) => x.permission);
        return AdminPermissions.toAdminModulePermissions(permsOnModule);
    }

    public static toAdminModulePermissions = (permissions: Array<PermissionType> = []): AdminPermissionsOnModule => {
        const canRead = AdminPermissions.hasReadPermission(permissions);
        const canWrite = AdminPermissions.hasWritePermission(permissions);
        return {
            canRead: canRead,
            canList: canRead,
            canCreate: canWrite,
            canImport: canWrite,
            canExport: canWrite || canRead,
            canSave: canWrite,
            canRemove: canWrite,

            canEditName: canWrite,
            canEditExternalReference: canWrite,
        };
    }

    //#endregion
}